import { Moon, Sun } from 'lucide-react';
import type { HTMLAttributes } from 'react';

import { Button, cn } from '../components/ui';
import { useTheme } from './useTheme';

export interface ThemeToggleProps extends HTMLAttributes<HTMLDivElement> {}

export function ThemeToggle({ className, ...props }: ThemeToggleProps) {
  const { isDark, toggle } = useTheme();

  return (
    <div className={cn('flex items-center gap-2', className)} {...props}>
      <Button
        variant="outline"
        size="sm"
        aria-label={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
        onClick={toggle}
        className="w-10 p-0"
      >
        {isDark ? <Sun className="h-4 w-4" aria-hidden /> : <Moon className="h-4 w-4" aria-hidden />}
      </Button>
    </div>
  );
}
